// extracted by mini-css-extract-plugin
module.exports = {"desc":"store-info_desc__H2u33"};